import React from 'react';
import { useNavigate } from 'react-router-dom';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PropTypes from 'prop-types';
import * as S from './styled.js'; // seu styled-component
import { getWhatsappUrl } from 'utils/whatsappLinkGenerator.js';
import { resolveImageUrl } from 'utils/apiOrigin.js';

const ProductPreview = ({ product }) => {
  const navigate = useNavigate();
  const displayPrice =
    product.promotionalPrice && product.promotionalPrice !== 'R$ 0,00'
      ? product.promotionalPrice
      : product.price;

  const handleCardClick = () => {
    navigate(`/product/${product.id}`);
  };

  const handleWhatsAppClick = (e) => {
    e.stopPropagation();
    window.open(getWhatsappUrl(product.id), '_blank');
  };

  return (
    <S.CardContainer onClick={handleCardClick}>
      <S.ImageWrapper>
        <S.ProductImage src={resolveImageUrl(product.mainImage)} alt={product.name} />
        {product.highlightedTag && <S.Tag>{product.highlightedTag}</S.Tag>}
      </S.ImageWrapper>

      <S.ProductInfo>
        <S.ProductName>{product.name}</S.ProductName>

        <S.Price>{displayPrice}</S.Price>

        <S.WhatsButton onClick={handleWhatsAppClick}>
          <WhatsAppIcon />
          <span>EU QUERO!</span>
        </S.WhatsButton>
      </S.ProductInfo>
    </S.CardContainer>
  );
};

ProductPreview.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    promotionalPrice: PropTypes.string,
    highlightedTag: PropTypes.string,
    mainImage: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductPreview;
